export default function fieldImage(fieldValue) {
    const hasBackground = fieldValue && fieldValue.src;
    const backgroundSrc = hasBackground ? 'url(' + fieldValue.src + ')' : '';
    return {
        hasBackground, backgroundSrc
    };
}
